import { render, staticRenderFns } from "./CreatorVideoBroadcast.vue?vue&type=template&id=8504dd82&scoped=true&"
import script from "./CreatorVideoBroadcast.vue?vue&type=script&lang=js&"
export * from "./CreatorVideoBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./CreatorVideoBroadcast.vue?vue&type=style&index=0&id=8504dd82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8504dd82",
  null
  
)

export default component.exports